import type { ReactNode, JSX } from 'react';

import { ErrorBoundary } from './error-boundary';
import { ErrorOverlay } from './error-overlay';

interface Props {
  children: ReactNode;
  onError?: (error: Error) => unknown;
}

/**
 * Catch errors thrown while rendering the application and keep the failed subtree unmounted.
 * NextApiError failures retain their status-specific messages.
 */
export function NextApiErrorBoundary(props: Props): JSX.Element {
  const { children, onError } = props;

  return (
    <ErrorBoundary onError={onError}>
      {(error) => {
        if (error) {
          return <ErrorOverlay error={error} />;
        }
        return children;
      }}
    </ErrorBoundary>
  );
}
